module.exports = __webpack_public_path__ + "img/kitchen-dining-lighting.18976c0.jpg";